export enum EPermissao {
    ALTERA_JOGO = 'ALTERA_JOGO',
    ALTERA_PULE = 'ALTERA_PULE',
    GERENCIA_PULE = 'GERENCIA_PULE',
    DELETA_PULE = 'DELETA_PULE',
    DESCONFIRMA_PULE = 'DESCONFIRMA_PULE',
    ALTERA_USUARIO_SENHA = 'ALTERA_USUARIO_SENHA'
}